import React, { useRef } from "react";
import jsPDF from "jspdf";
import AppBody from "../../components/AppBody";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTrainingCertificateDownload } from "../../../actions/learning_provider/provider_user/training_action";
import sclogo from "../../../images/logo/sclogo.jpeg";
const CertificationPdf = () => {
  const { slug } = useParams();
  const dispatch = useDispatch();
  const state = useSelector((state) => state.puTrainingReducer);

  useEffect(() => {
    dispatch(getTrainingCertificateDownload({ slug: slug }));
  }, []);

  const reportTemplateRef = useRef(null);
  const navigate = useNavigate();
  const handleGeneratePdf = () => {
    //"landscape", "px", "a4"
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "px",
    });
    // Adding the fonts.
    doc.setFont("Inter-Regular", "normal");
    doc.internal.write(0, "Tw");
    doc.html(reportTemplateRef.current, {
      async callback(doc) {
        await doc.save("certificate");
      },
    });
    // navigate("/my-trainings/");
  };

  //const link = "https://educloudlabs.com/certificate/verify/EDU-CLO-COM-0009";
  return (
    <AppBody
      loading={false}
      content={
        <div className="middle-sidebar-left">
          <div className="">
            <div className="card">
              <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
                <h4 className="font-xs text-white fw-600  mb-0 mt-2">
                  Certificate Download
                </h4>
              </div>
              <div className="card-body w-100 border-0 ">
                <button
                  onClick={() => handleGeneratePdf()}
                  className="btn-common px-5"
                  disabled={state && state.certificate.user_name ? false : true}
                >
                  Download
                </button>
                <div ref={reportTemplateRef}>
                  <div clas sName="certificate-container">
                    <div className="certificate">
                      <div className="water-mark-overlay"></div>
                      <div className="certificate-body">
                        <img src={sclogo} className="logo-img" />
                        <br />
                        <span class="dir-word">
                          {" "}
                          <b>
                            <i class="black-col"> a division of </i>{" "}
                            <span class="word-color">EDUCLOUDLABS</span>
                          </b>
                        </span>
                        <br />
                        <h2 className="certificate-title text-color">
                          <strong>
                            Sagarconsultants in association with MLBI
                          </strong>
                        </h2>
                        <h1 className="certifcate-hed">
                          Certificate of completion
                        </h1>
                        <p className="certificate-small-head">
                          This certificate is presented to
                        </p>
                        <p className="student-name">
                          {state && state.certificate.user_name
                            ? state.certificate.user_name
                            : " "}
                        </p>
                        <div className="certificate-content">
                          <div className="about-certificate">
                            <p className="about-certificate-par">
                              For completing{" "}
                              <b>
                                {" "}
                                {state && state.certificate.training_name
                                  ? state.certificate.training_name
                                  : " "}
                              </b>{" "}
                              program from 18th April to 06th May 2023.
                            </p>
                          </div>
                        </div>
                        <p className="b-col dir-line"> __________________</p>
                        <strong className="b-col dir-name">
                          Ajit Kshirsagar
                        </strong>
                        <p className="b-col dir-heading">Director</p>
                        <span className="ref-no black-col">
                          Ref No :  {state && state.certificate.ref_no
                            ? state.certificate.ref_no
                            : " "}
                        </span>
                        <span className="ref-link about-certificate-par black-col">
                          https://educloudlabs.com/certificate/verify/{state && state.certificate.ref_no
                          ? state.certificate.ref_no
                          : " "}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default CertificationPdf;
